import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { grey25 } from '@zocdoc/branding/colors';
import { LOCALIZED_STRINGS } from '../../../constants';
import { DropdownHeader, DropdownContainer } from '../../../dropdown';
import { Notification } from '../Notification';

const dataProdGuid = 'c398e880';

export default class NotificationList extends Component {
    static propTypes = {
        markNotificationsSeen: PropTypes.func.isRequired,
        markNotificationsSeenTimeout: PropTypes.number,
        notifications: PropTypes.array.isRequired,
        onNotificationClick: PropTypes.func,
        onSeeAllNotificationsClick: PropTypes.func,
    };

    static defaultProps = {
        markNotificationsSeenTimeout: 2000,
    };

    componentDidMount() {
        const {
            markNotificationsSeen,
            markNotificationsSeenTimeout,
        } = this.props;

        setTimeout(() => markNotificationsSeen(), markNotificationsSeenTimeout);
    }

    render() {
        const {
            notifications,
            onSeeAllNotificationsClick,
        } = this.props;

        const notificationsSection = notifications.length === 0 ? (
            <DropdownContainer data-test="no-notifications-message">
                <FormattedMessage
                    defaultMessage="Your notifications will show up here"
                    id="Layout.Header.NoNotifications"
                />
            </DropdownContainer>) :
            this.renderNotifications();

        return (
            <div>
                <DropdownHeader>
                    <FormattedMessage {...LOCALIZED_STRINGS.Notifications} />
                </DropdownHeader>

                <Notifications data-test="notifications-container">
                    {notificationsSection}
                </Notifications>

                <NotificationsLink
                    data-prod-guids={`view-all-notifications-link:[${dataProdGuid}]`}
                    data-test="view-all-notifications-link"
                >
                    <DropdownContainer
                        data-test="see-all-notifications-link"
                        href="/patient/notifications"
                        onClick={onSeeAllNotificationsClick}
                    >
                        <FormattedMessage
                            defaultMessage="See all notifications"
                            id="Layout.Header.SeeAllNotifications"
                        />
                    </DropdownContainer>
                </NotificationsLink>
            </div>
        );
    }

    renderNotifications() {
        const { notifications, onNotificationClick } = this.props;

        return notifications.filter(notification => 'id' in notification).map((notification, i) =>
            (
                <Notification
                    key={i}
                    notification={notification}
                    onNotificationClick={onNotificationClick}
                />
            ));
    }
}

const Notifications = styled.div`
    max-height: 50vh;
    overflow-y: auto;
`;

const NotificationsLink = styled.div`
    border-top: 1px solid ${grey25};
`;
